<script>
export default
{
    name: 'mv-menu-item',

    props:
    {
        target: String,
        icon: String,
        text: String,
        exact: Boolean,
    }
}
</script>

<template>
<router-link tag="li" active-class="active" :to="target" :exact="exact">
    <a>
        <icon :name="icon"></icon>
        <span class="link-text" v-html="text">

        </span>
    </a>
</router-link>
</template>

<style lang="scss">
@media (min-width:768px) {
    .link-text {
        display: none;
    }
}

@media (min-width:1200px) {
    .link-text {
        display: inline;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/sidebar/MenuItem.vue